/**
 * @generated SignedSource<<acb2b226c571920133805039d5b23b8e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegateCard_Delegation$data = {
  readonly createdAt: string | null;
  readonly delegate: {
    readonly email: string;
    readonly fullName: string;
    readonly id: string;
    readonly image: string;
  };
  readonly delegator: {
    readonly email: string;
    readonly fullName: string;
    readonly id: string;
    readonly image: string;
  };
  readonly expiryDate: string | null;
  readonly id: string;
  readonly lastAccessed: string | null;
  readonly " $fragmentType": "DelegateCard_Delegation";
};
export type DelegateCard_Delegation$key = {
  readonly " $data"?: DelegateCard_Delegation$data;
  readonly " $fragmentSpreads": FragmentRefs<"DelegateCard_Delegation">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "image",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DelegateCard_Delegation",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiryDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastAccessed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "delegator",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "delegate",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Delegation",
  "abstractKey": null
};
})();

(node as any).hash = "9bf7e5763ca66193ec69395de5b75ada";

export default node;
